import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import gis from "../../Assets/Projects/gis.svg";
import streamify from "../../Assets/Projects/streamify.svg";
import algo from "../../Assets/Projects/algo.svg";
import compressor from "../../Assets/Projects/compressor.svg";
import connectin from "../../Assets/Projects/connectin.svg";
import bitcoin from "../../Assets/Projects/bitcoin.svg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects feel free to visit My Gitlab / Github to view more. 
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={algo}
              title="AlgoEasy"
              description="App which makes algo easy to understand algorithms with its visually appealing game like UI and animations (Auto Maze Generator for Dijkstra Algorithm)"
              link="https://gitlab.com/BURFAL18/AlgoEasy"
              demolink="https://burfal18.github.io/AlgoEasy"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={connectin}
              title="ConnectIN"
              description="A fully functional application made for people to connect , talk , share ideas , images and build connection . It is made using MERN Stack and uses MongoDB Atlas as DB hosted in cloud."
              link="https://gitlab.com/BURFAL18/ConnectIN"
              demolink="https://gitlab.com/BURFAL18/ConnectIN/-/blob/master/README.md"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={compressor}
              isBlog={false}
              title="ZIP-huff"
              description="Simple Text Compressor made using Huffman encoding Algorithm "
              link="https://burfal18.github.io/ZIP-huff"
              demolink="https://burfal18.github.io/ZIP-huff"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitcoin}
              isBlog={false}
              title="BitPrice"
              description="NextJs App which Check BitCoin Latest Price and show price in different Currency"
              link="https://github.com/BURFAL18/BitPrice"
              demolink="https://bit-price-q157dgkys-burfal18.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gis}
              title="GIS (Gifs and Image Searcher)"
              description="GIS gets royality free gifs and image depending upon user search and use these images anywhere .It made using React components and CSS."
              link="https://github.com/BURFAL18/Gif-Image-Searcher"
              demolink='https://burfal18.github.io/Gif-Image-Searcher/'
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={streamify}
              isBlog={false}
              title="streamify"
              description="Streamify is a streaming app. Where user can CREATE , VIEW , EDIT ,DELETE their streams. It is integrated with Oauth and can be used by anyone."
              link="https://github.com/BURFAL18/Streamify"
              demolink="https://github.com/BURFAL18/Streamify"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
